import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  companyDetails: null,
  addressCount: null,
  pickupAddresses: null,
  fetchCompanyDetails: false,
  fetchingCountries: false,
  fetchingStates: false,
  fetchingCities: false,
  countries: [],
  states: [],
  cities: [],
  totalAddresses: [],
};

const companyPickupAddressSlice = createSlice({
  name: "companyPickupAddress",
  initialState,
  reducers: {
    fetchCompanyPickupAddress(state, action) {
      state.loading = true;
    },
    fetchCompanyPickupAddressSuccess(state, action) {
      state.pickupAddresses = action.payload.data.document;
      state.addressCount = action.payload.count;
      state.loading = false;
    },
    fetchCompanyPickupAddressFailure(state, action) {
      state.loading = false;
    },
    fetchCompanyDetails(state, action) {
      state.fetchCompanyDetails = true;
    },
    fetchCompanyDetailsSuccess(state, action) {
      state.fetchCompanyDetails = false;
      state.companyDetails = action.payload.data.document;
    },
    fetchCompanyDetailsFailure(state, action) {
      state.fetchCompanyDetails = false;
    },
    fetchTotalPickupAddresses(state, action) {
      state.loading = true;
    },
    fetchTotalPickupAddressesSuccess(state, action) {
      state.totalAddresses = action.payload.data.document;
      state.loading = false;
    },
    fetchTotalPickupAddressesFailure(state, action) {
      state.loading = false;
    },
    fetchCountries(state, action) {
      state.fetchingCountries = true;
    },
    fetchCountriesSuccess(state, action) {
      state.fetchingCountries = false;
      state.countries = action.payload.data.document;
    },
    fetchCountriesFailure(state, action) {
      state.fetchingCountries = false;
    },
    fetchStates(state, action) {
      state.fetchingStates = true;
    },
    fetchStatesSuccess(state, action) {
      state.fetchingStates = false;
      state.states = action.payload.data.document;
    },
    fetchStatesFailure(state, action) {
      state.fetchingStates = false;
    },
    fetchCities(state, action) {
      state.fetchingCities = true;
    },
    fetchCitiesSuccess(state, action) {
      state.fetchingCities = false;
      state.cities = action.payload.data.document;
    },
    fetchCitiesFailure(state, action) {
      state.fetchingCities = false;
    },
    addPickupAddress(state, action) {
      state.loading = true;
      state.error = null;
    },
    addPickupAddressSuccess(state, action) {
      state.loading = false;
      state.error = null;
    },
    addPickupAddressFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    updatePickupAddress(state, action) {
      state.loading = true;
      state.error = null;
    },
    updatePickupAddressSuccess(state, action) {
      state.error = null;
      state.loading = false;
    },
    updatePickupAddressFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    initializeState(state, action) {
      state.loading = false;
      state.error = null;
      state.companyDetails = null;
      state.addressCount = null;
      state.pickupAddresses = null;
      state.fetchCompanyDetails = false;
      state.fetchingCountries = false;
      state.fetchingStates = false;
      state.fetchingCities = false;
      state.countries = [];
      state.states = [];
      state.cities = [];
    },
  },
});

export const { actions, reducer, name: sliceKey } = companyPickupAddressSlice;
